import app from './app';
import auth from './auth';
import library from './library';
import location from './location';
import locationImport from './locationImport';
import alert from './alert';
import alertType from './alertType';
import user from './user';
import account from './account';
import brand from './brand';
import utils from './utils';
import support from './support';
import ota from './ota';
import healthCheck from './healthCheck';
import search from './search';

export default {
  ...app,
  ...auth,
  ...library,
  ...location,
  ...locationImport,
  ...alert,
  ...alertType,
  ...user,
  ...account,
  ...brand,
  ...utils,
  ...support,
  ...ota,
  ...healthCheck,
  ...search,
};
